export default {
  title: 'Velkommen',
  subtitle: 'Log ind for at administrere din konto og dine ordrer',
  benefits: {
    earn_points: {
      title: 'Optjen point med hver ordre',
      description: 'Saml point og lås op for eksklusive belønninger',
    },
    get_deals: {
      title: 'Få eksklusive rabatter',
      description: 'Brug dine point til at få gratis varer',
    },
    redeem_points: {
      title: 'Indløs point til gratis mad',
      description: 'Få adgang til tilbud kun for medlemmer',
    },
  },
};
